"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplyButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _ButtonTs = _interopRequireDefault(require("@lt/components/components/ButtonTs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ApplyButton = function ApplyButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      buttonRef = _ref.buttonRef,
      isHotelVariant = _ref.isHotelVariant;
  return /*#__PURE__*/_react["default"].createElement(StyledButton, {
    className: className,
    disabled: disabled,
    size: "large",
    offHover: true,
    onClick: onClick,
    buttonRef: buttonRef,
    $isHotelVariant: isHotelVariant
  }, children);
};

exports.ApplyButton = ApplyButton;
var StyledButton = (0, _styledComponents["default"])(_ButtonTs["default"]).withConfig({
  displayName: "ApplyButton__StyledButton",
  componentId: "sc-xhjnke-0"
})(["&&{display:flex;align-items:center;justify-content:center;", " border-radius:var(--border-radius);border:none;font-size:14px;transition:0.3s;padding:12px 16px;height:38px;&:hover{transform:scale(1.02);}}"], function (_ref2) {
  var $isHotelVariant = _ref2.$isHotelVariant;
  return $isHotelVariant ? "background-color: var(--secondary); \n      color: var(--secondary-color);" : "background-color: var(--secondary-header); \n      color: var(--secondary-header-color);";
});